import {
  FETCH_LIQUIDACIONES_LISTA_SELLERS,
  FETCH_SELLERS_FILTER,
  FETCH_FACTURACIONES,
  FETCH_INTEGRADORES,
  SET_FILTRO_SELLER,
  FETCH_SELLERS,
  FETCH_SELLER,
  EDIT_SELLER,
  FETCH_PROVEEDORES_FILTER,
  LOADING_SELLERS,
  RESET_SELLERS,
  FETCH_PROVINCIAS_LOCALIDADES,
  CLEAR_LOCALIDAD_PROVINCIA,
  SET_LOGISTICA_PROPIA,
  SET_LOGISTICA_CACHE,
  SET_LOGISTICA_DIRTY,
  CLEAR_LOGISTICA_FOR_SELLER
} from './types';
import {
  getSeller,
  listSellersParameters,
  getIntegradores,
  getTipoFacturacion,
  getLiquidacionesListaSellers,
  fetchDesplegableProveedoresApi,
  getProvinciaLocalidadByCodigoPostalApi,
  fetchLogisticaPropiaApi,
  updateLogisticaPropiaApi,
  putEstadoSellerApi,
  getSellerDesplegable
} from "../api/axios";
import { parseFieldValueForUpdate } from '../utilities/Seller/parseFieldValueForUpdate';

const toArray = (data) => {
  // Si por algún motivo llega como string, intentar parsear
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      data = (typeof parsed === 'string') ? JSON.parse(parsed) : parsed;
    } catch (_) { }
  }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.elementos)) return data.elementos;
  if (Array.isArray(data?.content)) return data.content;
  // Shape observado: { page, pageSize, total, content: [ { datosSellerDesplegables: [...] } ] }
  if (Array.isArray(data?.content?.[0]?.datosSellerDesplegables)) return data.content[0].datosSellerDesplegables;
  // Variante: { content: { datosSellerDesplegables: [...] } }
  if (Array.isArray(data?.content?.datosSellerDesplegables)) return data.content.datosSellerDesplegables;
  if (Array.isArray(data?.Content?.[0]?.DatosSellerDesplegables)) return data.Content[0].DatosSellerDesplegables;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.paginateSellers?.elementos)) return data.paginateSellers.elementos;
  if (Array.isArray(data?.paginateSellers?.content)) return data.paginateSellers.content;
  if (Array.isArray(data?.PaginateSellers?.Elementos)) return data.PaginateSellers.Elementos;
  if (Array.isArray(data?.PaginateSellers?.Content)) return data.PaginateSellers.Content;
  if (Array.isArray(data?.paginationResponseSellers?.content)) return data.paginationResponseSellers.content;
  if (Array.isArray(data?.PaginationResponseSellers?.Content)) return data.PaginationResponseSellers.Content;
  return [];
};

/** Total de páginas para la UI (react-paginate usa cantidadPagina). La API suele mandar totalPages y no cantidadPagina. */
const resolveTotalPages = (paginateBlock, itemsLength = 0) => {
  const ps = paginateBlock;
  if (!ps || typeof ps !== 'object') return itemsLength > 0 ? 1 : 0;
  const num = (x) => {
    if (x === undefined || x === null || x === '') return null;
    const v = Number(x);
    return Number.isFinite(v) ? v : null;
  };
  const explicit = num(
    ps.cantidadPagina ?? ps.CantidadPagina ?? ps.totalPages ?? ps.TotalPages
  );
  if (explicit != null && explicit >= 0) return explicit;

  const total = num(ps.cantidadTotal ?? ps.CantidadTotal ?? ps.total ?? ps.Total);
  const pageSize = num(ps.pageSize ?? ps.PageSize) || 10;
  if (total != null && total >= 0) {
    return Math.max(0, Math.ceil(total / pageSize));
  }

  return itemsLength > 0 ? 1 : 0;
};

const normalizeSeller = (item) => ({
  ...item,
  codigo: item?.codigo ?? item?.Codigo ?? item?.idSeller ?? item?.IdSeller ?? 0,
  cuit: item?.cuit ?? item?.Cuit ?? "",
  telefono: item?.telefono ?? item?.Telefono ?? "",
  estado: item?.estado ?? item?.Estado ?? "",
  domicilio: item?.domicilio ?? item?.Domicilio ?? "",
  email: item?.email ?? item?.Email ?? "",
  emailDespacho: item?.emailDespacho ?? item?.EmailDespacho ?? "",
  numeroDomicilio: item?.numeroDomicilio ?? item?.NumeroDomicilio ?? "",
  localidad: item?.localidad ?? item?.Localidad ?? "",
  provincia: item?.provincia ?? item?.Provincia ?? "",
  codigoPostal: item?.codigoPostal ?? item?.CodigoPostal ?? "",
  idSeller: item?.idSeller ?? item?.IdSeller ?? item?.codigo ?? item?.Codigo ?? 0,
  razonSocial: item?.razonSocial ?? item?.RazonSocial ?? item?.descripcion ?? item?.Descripcion ?? ""
});

const normalizeSellersPage = (response) => {
  const items = toArray(response).map(normalizeSeller);

  if (response?.paginateSellers || response?.PaginateSellers) {
    const paginateSellers = response?.paginateSellers ?? response?.PaginateSellers ?? {};
    const merged = {
      ...paginateSellers,
      elementos: items,
      cantidadPagina: resolveTotalPages(
        { ...paginateSellers, elementos: items },
        items.length
      )
    };
    return {
      ...response,
      paginateSellers: merged
    };
  }

  if (response?.paginationResponseSellers || response?.PaginationResponseSellers) {
    const pagination = response?.paginationResponseSellers ?? response?.PaginationResponseSellers ?? {};
    const block = {
      elementos: items,
      cantidadTotal: pagination?.total ?? pagination?.Total ?? items.length,
      cantidadPagina: pagination?.totalPages ?? pagination?.TotalPages,
      page: pagination?.page ?? pagination?.Page ?? 1,
      pageSize: pagination?.pageSize ?? pagination?.PageSize ?? items.length
    };
    return {
      ...response,
      paginateSellers: {
        ...block,
        cantidadPagina: resolveTotalPages(block, items.length)
      }
    };
  }

  const fallbackBlock = {
    elementos: items,
    cantidadTotal: response?.cantidadTotal ?? response?.CantidadTotal ?? items.length,
    cantidadPagina: response?.cantidadPagina ?? response?.CantidadPagina,
    page: response?.page ?? response?.Page ?? 1,
    pageSize: response?.pageSize ?? response?.PageSize
  };
  return {
    paginateSellers: {
      ...fallbackBlock,
      cantidadPagina: resolveTotalPages(fallbackBlock, items.length)
    }
  };
};


export const fetchIntegradores = () => async dispatch => {
  let array = getIntegradores();
  let integradores;
  array.then(function (value) {
    integradores = value;

    dispatch({
      type: FETCH_INTEGRADORES,
      payload: integradores
    });
  });
}

export const fetchProveedoresFilter = (params) => async dispatch => {
  let options = [];
  const defaultParams = { Page: 1, PageSize: 10, ...params };
  let req = fetchDesplegableProveedoresApi(defaultParams);
  req.then((res) => {

    let data = [];
    // Handle new structure: { data: [{ codigo, descripcion }] }
    if (res && Array.isArray(res.data)) {
      data = res.data;
    }
    // Fallbacks for safety during transition/testing (optional, can be removed if strict)
    else if (res.paginationResponseProveedores && Array.isArray(res.paginationResponseProveedores.content)) {
      data = res.paginationResponseProveedores.content;
    } else if (res.elementos && Array.isArray(res.elementos)) {
      data = res.elementos;
    }

    if (data.length > 0) {
      options = data.map((proveedor) => {
        // Adapt to simpler structure (codigo, descripcion) or fallbacks
        const labelText = proveedor.descripcion || proveedor.Descripcion || proveedor.denomin || proveedor.Denomin || "";
        return {
          value: proveedor.codigo || proveedor.Codigo,
          label: labelText.trim()
        };
      });
    }

    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: options
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: []
    });
  });
}

export const setFiltroSeller = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_SELLER,
    payload: filtro
  });
}

export const fetchFacturaciones = () => async dispatch => {
  let array = getTipoFacturacion();
  let facturaciones;
  array.then(function (value) {

    facturaciones = value;
    dispatch({
      type: FETCH_FACTURACIONES,
      payload: facturaciones
    });
  });
}

export const fetchSellers = (Descripcion, CantidadPagina, NumeroPagina) => async dispatch => {
  dispatch({
    type: LOADING_SELLERS,
    payload: true
  });

    let array = listSellersParameters(Descripcion, CantidadPagina ?? '0', NumeroPagina ?? '0');

  array
    .then((sellers) => {
      dispatch({
        type: FETCH_SELLERS,
        payload: normalizeSellersPage(sellers)
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_SELLERS,
        payload: normalizeSellersPage({ paginateSellers: { elementos: [] } })
      });
    })
    .finally(() => {
      dispatch({
        type: LOADING_SELLERS,
        payload: false
      });
    });
}

export const fetchSellersFilter = (params) => async dispatch => {
  let req = getSellerDesplegable(params);
  req.then((res) => {
    // Normalización defensiva: la API puede devolver wrappers distintos.
    const data = res ?? {};
    const rawList =
      Array.isArray(data?.content?.[0]?.datosSellerDesplegables) ? data.content[0].datosSellerDesplegables
        : Array.isArray(data?.Content?.[0]?.DatosSellerDesplegables) ? data.Content[0].DatosSellerDesplegables
          : toArray(data);

    const mappedSellers = (rawList || []).map((rawSeller) => {
      const seller = normalizeSeller(rawSeller);
      return {
        ...seller,
        value: seller.idSeller,
        label: seller.razonSocial
      };
    }).filter(s => s.value != null && String(s.value) !== "" && (s.label ?? "") !== "")
      .filter(s => ![1, 3, 4, 5, 6].includes(Number(s.value)));

    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: mappedSellers
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: []
    });
  });
}

export const fetchSeller = (id) => async dispatch => {

  let seller;
  if (typeof id !== 'undefined') {

    let sellers = getSeller(id);
    sellers.then(function (value) {
      const normalized = normalizeSellersPage(value);
      seller = normalized?.paginateSellers?.elementos?.[0];

      if (!seller && value?.seller) seller = normalizeSeller(value.seller);
      if (!seller && value?.Seller) seller = normalizeSeller(value.Seller);
      if (!seller) seller = {};

      dispatch({
        type: FETCH_SELLER,
        payload: seller
      });
    });
  } else {
    seller = {
      codigo: '',
      codigoPostal: '',
      cuit: '',
      domicilio: '',
      email: '',
      emailUsuario: '',
      emailDespacho: '',
      estado: '',
      idEstado: 1,
      integrador: 1,
      localidad: '',
      numeroDomicilio: '',
      provincia: '',
      razonSocial: '',
      telefono: '',
      tipoFacturacion: 1,
      urlPushOrdenes: '',
      sufijo: '',
      idEmpresaEnviopack: 0,
      nombreUsuario: '',
      nombreTienda: '',
      logo: '',
      tiendaActiva: false,
      internacional: false,
      emisionFacturaA: false,
    }

    dispatch({
      type: FETCH_SELLER,
      payload: seller
    });
  }
}

export const editSeller = (seller) => dispatch => {
  dispatch({
    type: EDIT_SELLER,
    payload: seller
  });
}

export const fetchLiquidacionesListaSellers = () => async dispatch => {
  let array = getLiquidacionesListaSellers();
  array.then(function (value) {
    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: value.listaSellersLiquidaciones
    });
  });
}

export const resetSellers = () => async dispatch => {
  dispatch({
    type: RESET_SELLERS,
    payload: []
  })
};

export const updateListSellers = (sellersArray, seller) => async (dispatch) => {
  const elementos = sellersArray?.paginateSellers?.elementos;

  if (!Array.isArray(elementos) || elementos.length === 0) {
    // No hay elementos para actualizar, salir
    return;
  }

  const existe = elementos.some(item =>
    item.codigo === seller.codigo
  );

  if (!existe) {
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: [], // no hay cambios, no se actualiza
    });
    return;
  }

  const nuevosElementos = elementos.map(item =>
    item.codigo === seller.codigo ? seller : item
  );

  const updatedSellersArray = {
    ...sellersArray,
    paginateSellers: {
      ...sellersArray.paginateSellers,
      elementos: nuevosElementos,
    },
  };

  dispatch({
    type: 'UPDATE_SELLERS_LIST',
    payload: updatedSellersArray,
  });
};

export const changeSellerStatus = (seller, newStatus) => async (dispatch, getState) => {
  const { sellers } = getState().sellers;
  const originalState = structuredClone(sellers); // Forma moderna de hacer Json.parse(JSON.stringify())

  // Optimistic update
  const updatedSeller = { ...seller, estado: newStatus };
  dispatch(updateListSellers(sellers, updatedSeller));

  try {
    const request = {
      listRequest: [
        {
          idSeller: seller.codigo,
          idEstado: newStatus === "activo" ? 1 : 2
        }
      ]
    };
    await putEstadoSellerApi(request);
  } catch (error) {
    // Revert on error
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: originalState,
    });
    throw error;
  }
};

export const fetchProvinciaLocalidadByCodigoPostal = (data) => async (dispatch) => {

  try {
    const res = await getProvinciaLocalidadByCodigoPostalApi(data);

    dispatch({
      type: FETCH_PROVINCIAS_LOCALIDADES,
      payload: res.localidadProvincia
    });
  } catch (error) {
    console.error("Error al obtener provincias/localidades", error);
  }
};

export const clearLocalidadProvincia = () => ({
  type: CLEAR_LOCALIDAD_PROVINCIA
});


export const fetchLogisticaPropia = (idSeller, { force = false } = {}) =>
  async (dispatch, getState) => {
    const cached = getState().sellers.logisticaCache?.[idSeller];

    // ✅ si hay caché, úsala (aunque esté dirty). Evita “pegadas” al cambiar de tab.
    if (!force && cached?.data) {
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: cached.data });
      return cached.data;
    }

    // si no hay caché o pedís force, pegá
    const data = await fetchLogisticaPropiaApi(idSeller);
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: data });
    return data;
  };



export const updateLogisticaEscalaField =
  ({ idSeller, idEscala, zona, field, value }) =>
    (dispatch, getState) => {
      const lp = getState().sellers.logisticaPropia || { escalas: [] };

      const next = structuredClone(lp);
      const esc = next.escalas.find(e => e.idEscala === idEscala);
      if (!esc) return;

      const parsed = parseFieldValueForUpdate(field, value);

      esc[zona] = esc[zona] || {};
      esc[zona][field] = parsed;

      // Actualiza la activa para render inmediato
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });

      // Marca dirty y guarda en caché bajo la clave CORRECTA (idSeller)
      if (idSeller != null) {
        dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
        dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
      }
    };
export const submitLogisticaPropia = ({ idSeller, zonas, bodyFromState }) =>
  async (dispatch) => {
    await updateLogisticaPropiaApi({ idSeller: Number(idSeller), zonas });

    // opcional: o bien forzar un GET fresco…
    // const data = await fetchLogisticaPropiaApi(idSeller);

    // …o confiar en lo que tenés en memoria (bodyFromState) y marcar clean:
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: bodyFromState, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: bodyFromState });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: false } });
  };

export const clearLogisticaForSeller = (idSeller) => (dispatch) => {
  dispatch({ type: CLEAR_LOGISTICA_FOR_SELLER, payload: { idSeller } });
};


// helpers locales
const ZONES = ['amba', 'interior', 'patagonia'];
const clone = (o) => structuredClone(o);

/**
 * Inicializa lp.zonasUI a partir de escalas/envioGratisZona si aún no existe.
 * No pisa si ya existe.
 */
export const initZonasUI = (idSeller) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  // si ya existe, no hacemos nada
  if (lp.zonasUI) return;

  const escalas = lp.escalas || [];
  const envioGratisZona = lp.envioGratisZona || {};
  const zonasUI = {};

  ZONES.forEach((z) => {
    const enabled = escalas.some(e => e[z] !== null && typeof e[z] === 'object');
    const envioGratis = !!envioGratisZona[z];
    zonasUI[z] = { enabled, envioGratis };
  });

  const next = { ...lp, zonasUI };

  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: false } });
};

/**
 * Toggle/Set de switches: enabled / envioGratis
 * Reglas:
 *  - Si deshabilito enabled => envioGratis = false
 *  - No permito marcar envioGratis si enabled está false
 */
export const updateZonaToggle = ({ idSeller, zona, field, value }) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  const next = clone(lp);
  next.zonasUI = next.zonasUI || {};
  const curr = next.zonasUI[zona] || { enabled: false, envioGratis: false };
  const updated = { ...curr };

  if (field === 'enabled') {
    updated.enabled = (value != null) ? !!value : !curr.enabled;
    if (!updated.enabled) updated.envioGratis = false;
  } else if (field === 'envioGratis') {
    if (!curr.enabled) return; // ignorar si no está habilitada
    updated.envioGratis = (value != null) ? !!value : !curr.envioGratis;
  }

  next.zonasUI[zona] = updated;

  // actualizo activa + cache y marco dirty
  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  if (idSeller != null) {
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
  }
};


